// @dynamic
export class CaseTransform {
  static snakeToCamelCase(value: string): string {
    return value
      ? value
          .replace(new RegExp(/_/g), ' ')
          .replace(/\b\w/g, (l) => l.toUpperCase())
          .replace(/\b\w/, (l) => l.toLowerCase())
          .replace(/\s/g, '')
      : value;
  }

  static lowerToTitleCase(value: string): string {
    // Code taken from https://github.com/gouch/to-title-case to support the proper spec.
    const smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;

    return value
      ? value.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, (match, index, title) => {
          if (
            index > 0 &&
            index + match.length !== title.length &&
            match.search(smallWords) > -1 &&
            title.charAt(index - 2) !== ':' &&
            (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
            title.charAt(index - 1).search(/[^\s-]/) < 0
          ) {
            return match.toLowerCase();
          }

          if (match.substr(1).search(/[A-Z]|\../) > -1) {
            return match;
          }

          return match.charAt(0).toUpperCase() + match.substr(1);
        })
      : value;
  }
}
